export default __webpack_public_path__ + "static/media/ninjacat.40616b9c.png";